import styled from '@emotion/styled';
import Spinner from '~/icons/spinner.svg';
import { keyframes } from '@emotion/react';

const ROTATING_ANIMATION = keyframes({
    to: { transform: 'rotate(360deg);' },
});

export const Container = styled.div({
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
});

export const LoaderSpinner = styled(Spinner)(({ theme }) => ({
    width: '48px',
    height: '48px',
    marginRight: 'calc(' + theme.space[3] + ' - ' + theme.space[1] + ')',
    marginTop: '2px',
    animation: `${ROTATING_ANIMATION} 1.5s infinite`,
}));
